<template>
  <div class="comContent">
    <div class="expand-form">
      <searchForm v-model="searchData" @search="onSearch" :formItems="searchLabelList" @reset="resetForm">
        <div slot="right">
          <el-button size="small" type="primary" @click="checkDetails({}, 'create')">新建</el-button>
        </div>
      </searchForm>
    </div>
    <myTable :index="index" :page="page" :isLoading="loading" :table-data="tableData" :table-option.sync="tableOption"
      @page-change="getList">
      <template slot="goodsFrom" slot-scope="scope">
        <!-- 商品来源 -->
        {{ scope.row.goodsFrom | filtersGoodsFrom }}
      </template>

      <template slot="status" slot-scope="scope">
        {{ scope.row.status | filtersStatus }}
      </template>

      <template slot="activeTime" slot-scope="scope">
        {{ scope.row.startTime }}
        -
        {{ scope.row.endTime }}
      </template>
      <template slot="operation" slot-scope="scope">
        <div style="margin: 0 0px">
          <el-link type="primary" key="detail" :underline="false" @click="checkDetails(scope.row, 'detail')"
            v-if="scope.row.status !== 0" style="margin-right: 10px">
            详情
          </el-link>
          <el-link type="primary" key="goods" :underline="false" @click="checkDetails(scope.row, 'goods')"
            style="margin-right: 10px">
            活动商品
          </el-link>
          <!-- <el-link type="primary" key="linksrc" :underline="false" @click="checkLinkDetails(scope.row)"
            style="margin-right: 10px" v-if="scope.row.status !== 0">
            链接
          </el-link> -->
          <el-link type="primary" key="stop" :underline="false" @click="updateStatus(scope.row)"
            style="margin-right: 10px" v-if="scope.row.status == 1 || scope.row.status == 3">
            停止活动
          </el-link>
          <el-link type="primary" key="edit" :underline="false" @click="checkDetails(scope.row, 'edit')"
            style="margin-right: 10px" v-if="scope.row.status == 0">
            编辑
          </el-link>
          <el-link type="primary" key="detel" :underline="false" @click="deleteActive(scope.row, 'detel')"
            v-if="scope.row.status == 0" style="margin-right: 10px">
            删除
          </el-link>
        </div>
      </template>
    </myTable>
  </div>
</template>
<script>
const activeOptions = [
  {
    name: "待开始",
    id: 1,
  },
  {
    name: "进行中",
    id: 3,
  },
  {
    name: "已结束",
    id: 4,
  },
  {
    name: "已停止",
    id: 2,
  },
  {
    name: "草稿中",
    id: 0,
  },
];
import searchForm from "./component/searchForm.vue";
import myTable from "@/components/myTable";
import {
  activityList,
  activityStartOrStop,
  activityDelete,
} from "@/api/platActivityManage";

export default {
  components: { searchForm, myTable },
  props: {},
  data() {
    return {
      loading: false,
      index: false,
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "活动id", prop: "id" },
        { label: "活动名称", prop: "name" },
        { label: "商品来源", prop: "goodsFrom", slot: true, },
        { label: "活动时间", prop: "activeTime", slot: true, width: 330 },
        { label: "参加店铺总数", prop: "storeSum" },
        { label: "参加SKU总数", prop: "skuSum" },
        { label: "活动状态", prop: "status", slot: true },
        { label: "更新人", prop: "updateBy" },
        { label: "更新时间", prop: "updateTime" },
        { label: "操作", prop: "operation", slot: true },
      ],
      searchData: this.searchDataInit(),
      searchLabelList: [
        {
          name: "搜索活动名称",
          fieldName: "activityName",
          type: "input",
        },
        {
          fieldName: "activityTime",
          startName: "活动开始时间",
          endName: "活动结束时间",
          type: "daterange",
          width: 260,
        },
        {
          name: "筛选活动状态",
          width: 150,
          fieldName: "status",
          type: "select",
          select: activeOptions,
        },
      ],
    };
  },
  filters: {
    filtersStatus(e) {
      for (let i = 0; i < activeOptions.length; i++) {
        if (e == activeOptions[i].id) {
          return activeOptions[i].name;
        }
      }
    },
    filtersGoodsFrom(t) {
      // 0平台添加 1 商户添加
      let txt = t
      switch (t) {
        case 0:
          txt = '平台添加';
          break
        case 1:
          txt = '商户添加';
          break
      }
      return txt
    }
  },
  created() { },
  mounted() {
    this.getList();
  },
  methods: {
    onSearch() {
      this.page.current = 1;
      this.getList();
    },
    resetForm() {
      this.page.current = 1;
      this.searchData = this.searchDataInit();
      this.getList();
    },
    searchDataInit() {
      return {
        activityName: '',
        activityTime: [],
        status: ''
      }
    },
    getList() {
      const { activityTime, ...form } = this.searchData;
      const { current, size } = this.page;
      const params = {
        ...form,
        current,
        size
      };
      if (activityTime && activityTime.length) {
        params.strTime = activityTime[0];
        params.endTime = activityTime[1];
      }
      this.loading = true
      activityList(params).then((res) => {
        this.tableData = res.records || [];
        this.page.total = res.total || 0;
      }).finally(() => {
        this.loading = false
      })
    },
    // 停止活动
    updateStatus(row) {
      this.$confirm(
        `活动停止后将不能重新开始，是否确认停止【${row.name}】？`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          title: `停止活动`,
        }
      )
        .then(({ value }) => {
          activityStartOrStop(row.id).then((res) => {
            this.$message.success("操作成功！");
            this.getList();
          });
        })
        .catch((err) => {
          console.log("取消操作");
        });
    },

    deleteActive(row) {
      this.$confirm(`确认删除活动【${row.name}】么？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        title: "删除活动",
      })
        .then(({ value }) => {
          activityDelete(row.id).then((res) => {
            this.$message.success("操作成功！");
            this.getList();
          });
        })
        .catch((err) => {
          console.log("取消操作");
        });
    },
    // 查看详情
    checkDetails(row, type) {
      if (type == "create") {
        this.$router.push({
          path: "./platActivityManage-createActivity",
          query: {},
        });
      }
      if (type == "detail" || type == "edit") {
        this.$router.push({
          path: "./platActivityManage-activityDetail",
          query: { id: row.id, type: type },
        });
      }
      if (type == "goods") {
        this.$router.push({
          path: "./platActivityManage-activityGoodsList",
          query: { id: row.id, type: type },
        });
      }
    },
    // 链接
    // checkLinkDetails(
    //   e,
    //   rowData = { link: "http://aaa.vom", appLink: "app://ssssa" }
    // ) {
    //   const h = this.$createElement;
    //   const divDataList = [
    //     { text: "PC落地页链接：", link: rowData.link },
    //     { text: "App落地页链接：", link: rowData.appLink },
    //   ];
    //   const VNodeRow = [];
    //   const rowStyle =
    //     "display: flex;align-items: center;justify-content: space-between;margin-bottom: 5px;";
    //   divDataList.forEach((row) => {
    //     const button = h(
    //       "el-button",
    //       {
    //         props: { size: "mini", type: "primary" },
    //         on: {
    //           click: () => this.handleLinkCopy(row),
    //         },
    //       },
    //       "复制"
    //     );
    //     const span = h("span", `${row.text}${row.link}`);
    //     const vnode = h("div", { style: rowStyle }, [span, button]);
    //     VNodeRow.push(vnode);
    //   });

    //   this.$msgbox({
    //     title: "链接",
    //     message: h("div", null, VNodeRow),
    //     showCancelButton: false,
    //     confirmButtonText: "关 闭",
    //   }).then((action) => { });
    // },
    // 复制链接
    // handleLinkCopy(e) {
    //   console.log("handleLinkClick", e);
    // },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.zt__table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.expand-form {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .btns-box {
    display: flex;
    align-items: center;
    margin-bottom: 13px;
  }
}
</style>
